/* eslint-disable react/prop-types, no-unused-vars */

import { Form, Select, Input } from 'antd';

const ReplaceValuesForm = ({ config, columns, onChange }) => (
    <Form layout="vertical" initialValues={config} onValuesChange={(_, values) => onChange(values)}>
        <Form.Item label="Column" name="column" rules={[{ required: true }]}>
            <Select placeholder="Select column" options={columns.map(c => ({ label: c, value: c }))} />
        </Form.Item>
        <Form.Item label="Find Value" name="findValue" rules={[{ required: true }]}>
            <Input placeholder="Value to find" />
        </Form.Item>
        <Form.Item label="Replace With" name="replaceValue" rules={[{ required: true }]}>
            <Input placeholder="Replacement value" />
        </Form.Item>
    </Form>
);

export default ReplaceValuesForm;
